import Cookies from 'js-cookie';

import { isLocal } from '@lcsc-ui/utils/baseUrl';
import { doGet, doPost } from '@lcsc-ui/utils/request';

let APIHost = '/lcsc-op';
if (isLocal) {
  APIHost = 'https://devop.szlcsc.com';
}

// node请求接口
export default {
  websiteSection: `${APIHost}/website/section/list`,
};

// client请求接口
let domain = 'lcscOpUrl';
if (isLocal) {
  domain = 'https://devop.szlcsc.com';
}

export function getWebsiteSectionList() {
  return doGet(domain, '/website/section/list');
}

export function overseaSloganList() {
  return doGet(domain, '/oversea/slogan/list');
}

export function advertisingRightSide() {
  return doGet(domain, '/advertising/right/side');
}

export function abtestPing() {
  const fingerId = Cookies.get('_lcsc_fid');
  return doGet(domain, '/abtest/ping', { fingerId });
}

export function getBomPopoverAd() {
  return doGet(domain, '/advertising/bom/upload/popup');
  // 活动列表页侧边栏广告
}

export function advertisingHotSide(query) {
  return doGet(domain, '/advertising/hot/side', query);
}

export function researchPopupVisible(params) {
  return doGet(domain, '/is/research/popup', params);
}

export function researchPopupClose(params) {
  return doGet(domain, '/async/research/popup/close', params);
}

export function researchPopupSave(data) {
  return doPost(domain, '/async/research/popup/save', data);
}
